function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M176.343 195.314V231H8.94499V202.776L99.132 117.131C109.297 107.398 116.11 98.9636 119.57 91.8265C123.247 84.4731 125.085 77.2278 125.085 70.0907C125.085 59.4932 121.517 51.3829 114.379 45.7597C107.242 40.1365 96.753 37.3249 82.9113 37.3249C59.7698 37.3249 42.0352 45.219 29.7075 61.0071L0.185818 38.2982C9.05313 26.403 20.9483 17.2113 35.8713 10.723C51.0107 4.01845 67.8802 0.666177 86.4799 0.666177C111.135 0.666177 130.816 6.50563 145.523 18.1845C160.23 29.8634 167.583 45.7597 167.583 65.8734C167.583 78.2011 164.988 89.7718 159.797 100.586C154.607 111.399 144.658 123.727 129.951 137.569L69.286 195.314H176.343Z"
});

function SvgMenuNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 231,
    viewBox: "0 0 177 231",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNumber);
export default __webpack_public_path__ + "static/media/menu-number.d6862d41.svg";
export { ForwardRef as ReactComponent };